__turbopack_context__.v({
  "actions": "DocumentActions-module__Uk8gVG__actions",
  "copy": "DocumentActions-module__Uk8gVG__copy",
  "menu": "DocumentActions-module__Uk8gVG__menu",
  "more": "DocumentActions-module__Uk8gVG__more",
  "status": "DocumentActions-module__Uk8gVG__status",
});
